import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../localization'
import { PaymentFollowUp } from '../../types/paymentFollowUps'
import FollowUpAmount from './amount'
import { settlementActionLabel } from './labels'
import { projectionPending } from './settlement'

export default function OutstandingActions({
  followUp
}: {
  followUp: PaymentFollowUp
}) {
  return (
    <div>
      {projectionPending(followUp) && (
        <Typography component="p" role="status" color="textSecondary">
          {getTranslate(
            'Review update pending. Refresh before recording settlement.'
          )}
        </Typography>
      )}
      {followUp.outstandingByAction?.map((row) => (
        <div key={row.action}>
          <Typography component="span" variant="body2">
            {settlementActionLabel(row.action)}:{' '}
          </Typography>
          {row.knownAmount != null && row.knownAmount > 0 && (
            <FollowUpAmount amount={row.knownAmount} currency={row.currency} />
          )}
          {row.hasUnknownAmount && (
            <Typography component="span" variant="body2">
              {row.knownAmount != null && row.knownAmount > 0 ? ' · ' : ''}
              {row.knownAmount != null && row.knownAmount > 0
                ? getTranslate('Additional amount needs reconciliation')
                : getTranslate('Needs reconciliation')}
            </Typography>
          )}
        </div>
      ))}
    </div>
  )
}
